import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` that only updates `delay`ms after
 * the input stops changing. Used to keep the range slider's live UI
 * responsive (it shows the raw value instantly) while the expensive part —
 * re-rendering every visible FontCard at the new size — only fires once
 * the user pauses.
 */
export function useDebouncedValue(value, delay = 120) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timeoutId);
  }, [value, delay]);

  return debounced;
}
